import React from "react";
import { Box, Container, Grid, Typography, Paper } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

function FeaturesAdminPanel() {
  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #d2c2f2, #903AF2 50%)",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        py: 5,
      }}
    >
      <Container maxWidth="lg">
        {/* Título */}
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          mb={8}
          sx={{
            fontFamily: "'Red Hat Display', sans-serif",
            color: "#fff",
          }}
        >
          Tomá el control total de tu negocio
        </Typography>

        {/* Features */}
        <Grid container spacing={6}>
          {[
            {
              icon: <DashboardIcon sx={{ fontSize: 40, color: "#fff" }} />,
              bgColor: "#903AF2",
              title: "Gestión Centralizada",
              description:
                "Accedé a todas las reservas, clientes y pagos desde un solo lugar. Menos caos, más organización.",
            },
            {
              icon: <PeopleIcon sx={{ fontSize: 40, color: "#fff" }} />,
              bgColor: "#EE964B",
              title: "Administración de Clientes",
              description:
                "Gestioná fácilmente el historial de cada cliente, sus reservas y sus preferencias.",
            },
            {
              icon: <PaymentIcon sx={{ fontSize: 40, color: "#fff" }} />,
              bgColor: "#565254",
              title: "Control de Pagos",
              description:
                "Visualizá y administra los pagos de manera simple y segura, evitando errores y retrasos.",
            },
            {
              icon: <CalendarMonthIcon sx={{ fontSize: 40, color: "#fff" }} />,
              bgColor: "#EAF7CF",
              title: "Disponibilidad en Tiempo Real",
              description:
                "Sincronización en tiempo real para evitar sobreventas y optimizar cada reserva.",
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Box display="flex" alignItems="flex-start" gap={3}>
                <Paper
                  sx={{
                    backgroundColor: feature.bgColor,
                    borderRadius: 2,
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "64px",
                    minHeight: "64px",
                  }}
                >
                  {feature.icon}
                </Paper>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      fontFamily: "'Red Hat Display', sans-serif",
                      color: "#fff",
                      fontSize: { xs: "1.1rem", md: "1.25rem" },
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    mt={1}
                    sx={{
                      fontFamily: "'Merriweather Sans', sans-serif",
                      color: "#fff",
                    }}
                  >
                    {feature.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default FeaturesAdminPanel;
